import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
import { Ng2ImgToolsService } from 'ng2-img-tools';


@Injectable()
export class ComplaintsProvider{

  URL = environment.ismUrl;

  private options = { headers: new HttpHeaders().set('Content-Type', 'multipart/form-data') };

  constructor(public http: HttpClient, private storage: Storage, private imgTool: Ng2ImgToolsService) {}
  
  getComplaints(type: string, page_no?: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl("/my/complaints",val)+"&status="+type+"&per_page=10&page_no="+page_no)
        .toPromise();
      }
    });
  }

  getComments(id: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/comment/${id}`,val))
        .toPromise();
      }
    });
  }

  getJobCards(id: number){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<any>(this.getUrl(`/getJobCards/${id}`,val))
        .toPromise();
      }
    });
  }

  getComplaintCategory(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/getcomplaintcategory`,val))
        .toPromise();
      }
    });
  }


  getSocietyConfiguration(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/getSocietyConfigurationToResident/${val.societyId}`,val))
        .toPromise();
      }
    });
  }

  // private getComplaintSubcategory(){
  //   return this.getToken().then((val) => {
  //     if(val){
  //       return this.http.get<Response>(this.getUrl(`/getcomplaintsubcategory`,val))
  //       .toPromise();
  //     }
  //   });
  // }

  // getAllCategories(){
  //   return this.storage.get('allCategories').then(val => {
  //     if(val){
  //       return val;
  //     }
  //     else{
  //       return Promise.all([this.getComplaintCategory(), this.getComplaintSubcategory()]).then((values) => {
  //         let complaintTypeList = values[0].complaintTypeList;
  //         let complaintSubtypeList = values[1].data;
  //         for(let p in complaintTypeList){
  //           complaintTypeList[p].sub_catagory = [{name: "Others"}];
  //           for(let q in complaintSubtypeList){
  //             if(complaintTypeList[p].id == complaintSubtypeList[q].complaint_category_id){
  //               complaintTypeList[p].sub_catagory.push(complaintSubtypeList[q]);
  //             }
  //           }
  //         }
  //         this.storage.set('allCategories',complaintTypeList);
  //         return complaintTypeList;
  //       });
  //     }
  //   });
  // }

  getCommonAreas(){
    return this.storage.get("commonArea").then(val => {
      if(val){
        return val;
      }else{
        return this.getToken().then((val) => {
          if(val){
            return this.http.get(this.getUrl(`/getAllCustomAndCommonArea`,val))
            .toPromise().then(val => {
              this.storage.set("commonArea", val);
              return val;
            });
          }
        });
      }
    });
  }

  getCustomAreas(){
    return this.storage.get("customAreas").then(val => {
      if(val){
        return val;
      }else{
        return this.getToken().then((val) => {
          if(val){
            return this.http.get<any>(this.getUrl(`/my/customareas`,val))
            .toPromise().then(val => {
              if(val.status == "success"){
                this.storage.set("customAreas", val.data);
                return val.data;
              }
            });
          }
        });
      }
    });
  }

  getCommonAreaName(id: number){
    return this.getCommonAreas().then(val => {
      if(val){
        let comArea = val.find(e => {
          return e.id == id;
        });
        return comArea.name;
      }
    })
  }

  addComplaint(data: any){
    var form_data = new FormData();

    for ( var key in data ) {
      form_data.append(key, data[key]);
    }

    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/addComplaint`,val), form_data)
        .toPromise();
      }
    });
  }

  updateComplaint(data: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<Response>(this.getUrl(`/updateComplaint`,val), data)
        .toPromise();
      }
    });
  }

  addComment(comment: string, id: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/addComment`,val), {
          remarks: comment,
          comp_id: id
        })
        .toPromise();
      }
    });
  }
  getAssociatedUnits(){
      return this.getToken().then((val) => {
        return this.http.get<any>(this.getUnitUrl(`/associatedunits`,val))
        .toPromise().then(val => {
          if(val.status == "success"){
            return val.data; 
      }
    })
  })
  }
  
  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }
  getUnitUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}&site_id=${val.societyId}&unit_no=${val.flat_no}`;
  }

  getComplaintStatusCount(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/my/complaintstatuscount`,val))
        .toPromise();
      }
    });
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}





// WEBPACK FOOTER //
// ./src/providers/complaints/complaints.ts